import { Injectable } from '@angular/core';
import { DeliveryFormStateService } from '../../customer-form/form-state/delivery-form-state.service';
import SlotService from '../../cart-process/slot.service';
import { CommonInfoService } from '../../cart-process/common-info.service';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../../external-interfaces/notification-provider.service';
import { DeliveryModeEnum } from '../../models/cartDetails/deliveryModeEnum.model';

interface PcpiInfo {
  pcpiText: string;
  pcpiParams: any;
}
@Injectable()
export class SummaryPricesTextsService {
  public btnText = '';
  public extraInfo = '';
  public pcpiInfo: PcpiInfo;
  public isVirginBrand = false;
  private deliveryModeName: DeliveryModeEnum;

  constructor(
    private deliveryFormState: DeliveryFormStateService,
    private slotService: SlotService,
    private commonInfo: CommonInfoService,
    private notificationProvider: NotificationProviderService
  ) {
    this.isVirginBrand = this.commonInfo.isVirginBrand;
    this.listenUpdates();
  }

  public getBackButtonText(): string {
    return this.commonInfo.pageStep === 4
      ? 'Powrót na stronę główną'
      : this.isVirginBrand ? 'Zmień ofertę' : 'Kontynuuj zakupy';
  }

  private listenUpdates(): void {
    this.deliveryFormState.subscribe((params) => {
      this.deliveryModeName = params.deliveryModeName;

      setTimeout(() => {
        this.update();
      });
    });

    this.notificationProvider.subscribe(NotificationProviderTypeEnum.SLOTS_SERVICE, () => {
      this.update();
    });
  }

  private getButtonText(): string {
    switch (this.commonInfo.pageStep) {
      case 1:
      case 2:
        return 'Dalej';

      case 3:
        const showTextOrder = this.deliveryModeName === DeliveryModeEnum.COURIER &&
          this.slotService.hasAtLeastOneDeviceInSlots();

        return showTextOrder ? 'Zamawiam' : 'Zamawiam z obowiązkiem zapłaty';

      case 4:
        return 'Powrót na stronę główną';
    }
  }

  private getExtraInfo(): string {
    switch (this.commonInfo.pageStep) {
      case 1:
        if (!this.commonInfo.isOtherSalesOffer
          && !this.commonInfo.isRetentionOffer
          && !this.commonInfo.isRetentionMultiOffer
          && !this.commonInfo.isNextSim) {
          return this.commonInfo.isVirginBrand ? 'W następnym kroku będziesz potrzebować <b>dowodu osobistego</b>' : 'W następnym kroku będziesz potrzebować dowodu osobistego.';
        } else {
          return '';
        }

      case 2:
      case 3:
        const showExtraInfo = this.deliveryModeName === DeliveryModeEnum.COURIER && !this.commonInfo.isOtherSalesOffer;
        const isB2bRetentionOfferWithoutDevice =
          !this.commonInfo.b2c
          && this.commonInfo.isRetentionOffer
          && !this.slotService.hasAtLeastOneDeviceInCart();

        if (isB2bRetentionOfferWithoutDevice) {
          return 'Akceptacja koszyka oznacza realizację jednolitej gospodarczo transakcji w rozumieniu przepisów ustawy o VAT.';
        } else if (showExtraInfo) {
          return 'Po złożeniu zamówienia nie będziesz mógł go edytować. Umowę zawierasz dopiero poprzez podpisanie dokumentów dostarczonych przez kuriera.';
        } else {
          return '';
        }

      case 4:
        return '';
    }
  }

  private getPcpiInfo(): PcpiInfo {
    let pcpiInfo: PcpiInfo;

    if (this.commonInfo.isServiceTypeMix || this.commonInfo.isOtherSalesOffer) return;

    const termOfServiceNumber = this.slotService.slots[0]?.termOfServiceNumber;
    const isB2b = !this.commonInfo.b2c;
    const currency = !isB2b ? 'zł/mies.' : 'zł + VAT';
    const pcpiPrice1 = isB2b ? this.commonInfo.pcpiPrices?.pcpi1?.net : this.commonInfo.pcpiPrices?.pcpi1?.gross;
    const pcpiPrice2 = isB2b ? this.commonInfo.pcpiPrices?.pcpi2?.net : this.commonInfo.pcpiPrices?.pcpi2?.gross;

    if (Number(pcpiPrice1) > 0 && Number(pcpiPrice2) === 0) {
      termOfServiceNumber > 0 ?
        pcpiInfo = {
        pcpiText: 'pcpi.oneStep.withCommitment',
        pcpiParams: {commitment: termOfServiceNumber, price1: pcpiPrice1, currency}
        }
      : pcpiInfo = {
        pcpiText: 'pcpi.oneStep.noCommitment',
        pcpiParams: {price1: pcpiPrice1, currency}
      };
    } else if (Number(pcpiPrice1) > 0 && Number(pcpiPrice2) > 0) {
      termOfServiceNumber > 0 ?
        pcpiInfo = {
        pcpiText: 'pcpi.twoSteps.withCommitment',
        pcpiParams: {commitment: termOfServiceNumber, price1: pcpiPrice1, price2: pcpiPrice2, currency}
        }
      : pcpiInfo = {
        pcpiText: 'pcpi.twoSteps.noCommitment',
        pcpiParams: {price1: pcpiPrice1, price2: pcpiPrice2, currency}
      };
    } else if (!this.isVirginBrand) {
      termOfServiceNumber > 0 ?
        pcpiInfo = {
        pcpiText: 'pcpi.basic.withCommitment',
        pcpiParams: {}
        }
      : pcpiInfo = {
        pcpiText: 'pcpi.basic.noCommitment',
        pcpiParams: {}
      };
    }

    return pcpiInfo;
  }

  private update(): void {
    this.btnText = this.getButtonText();
    this.extraInfo = this.getExtraInfo();
    this.pcpiInfo = this.getPcpiInfo();
  }
}
